import { Directive, ElementRef, AfterViewInit, Renderer2, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appFixedIconSizeRobust]'
})
export class FixedIconSizeRobustDirective implements AfterViewInit, OnDestroy {
  private observer: MutationObserver;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.setIconSize();
    this.observeChanges();
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private setIconSize() {
    const icon = this.el.nativeElement;
    // Set styles on mat-icon
    this.applyStyles(icon);
    // Set styles on SVG child if present
    const svg = icon.querySelector('svg');
    if (svg) {
      this.applyStyles(svg);
    }
  }

  private applyStyles(element: HTMLElement | SVGElement) {
    const style = (element as HTMLElement).style;
    style.setProperty('width', '24px', 'important');
    style.setProperty('height', '24px', 'important');
    style.setProperty('font-size', '24px', 'important');
    style.setProperty('min-width', '24px', 'important');
    style.setProperty('min-height', '24px', 'important');
    style.setProperty('max-width', '24px', 'important');
    style.setProperty('max-height', '24px', 'important');
    style.setProperty('line-height', '24px', 'important');
    style.setProperty('display', 'inline-flex', 'important');
    style.setProperty('align-items', 'center', 'important');
    style.setProperty('justify-content', 'center', 'important');
  }

  private observeChanges() {
    this.observer = new MutationObserver(() => {
      this.setIconSize();
    });
    this.observer.observe(this.el.nativeElement, { childList: true, subtree: true });
  }
}
